const preferenceButtons = document.querySelectorAll('[data-ipw-cookie-preferences]');

function waitForPrivacyBanner(timeout = 2500) {
  return new Promise((resolve) => {
    const startedAt = Date.now();
    const poll = () => {
      if (globalThis.privacyBanner?.showPreferences) {
        resolve(globalThis.privacyBanner);
        return;
      }
      if (Date.now() - startedAt >= timeout) {
        resolve(null);
        return;
      }
      globalThis.setTimeout(poll, 100);
    };
    poll();
  });
}

async function showCookiePreferences(button) {
  const privacyBanner = await waitForPrivacyBanner();
  if (privacyBanner) {
    await privacyBanner.showPreferences();
    return;
  }

  const fallbackUrl = button.dataset.fallbackUrl;
  if (fallbackUrl) globalThis.location.assign(fallbackUrl);
}

preferenceButtons.forEach((button) => {
  if (button.dataset.ipwCookiePreferencesReady === 'true') return;
  button.dataset.ipwCookiePreferencesReady = 'true';
  button.addEventListener('click', () => showCookiePreferences(button));
});
